<template>
    <div class="area">
        <Header ref="header" :headL='true' :title="title"></Header>
        <div class="content">
            <div class="tap">为方便您进行购买，请设置经营区域，否则不能进行交易</div>
            <div class="inputWidth">
                <van-field
                    v-model="addressName"
                    type="text"
                    required
                    @click="onArea"
                    maxlength = '11'
                    label="经营区域"
                    :readonly = 'true'
                    right-icon="arrow"
                    placeholder="请选择经营区域"
                />
                <van-field
                    v-if="shareShow"
                    v-model="code"
                    type="text"
                    required
                    label="邀请码"
                    placeholder="请输入邀请码"
                />
            </div>
            <div class="btn" @click="onSubmit">确定</div>
        </div>
        <areaList ref="area" :citiyValue='areaData.countryId' @onArea='onAreaData'></areaList>
    </div>
</template>
<script>
import Header from '../../common/header'
import { getShareCode } from '../api/api'
import areaList from './area'
import { Toast } from 'vant'
import { mapActions } from 'vuex'
export default {
    name: 'runArea',
    components: {
        Header,
        areaList
    },
    data () {
        return {
            title: '设置经营区域',
            addressName: '江苏省 南京市 玄武区',
            userInfo: '',
            shareShow: false,
            code: '',
            areaData: {
                provinceId: '320000000000',
                provinceName: '江苏省',
                cityId: '320100000000',
                cityName: '南京市',
                countryId: '320102000000',
                countryName: '玄武区'
            }
        }
    },
    methods: {
        ...mapActions(['createCompany', 'getUserInfoData']),
        onArea () {
            this.$refs.area.onShow()
        },
        onAreaData (data) {
            this.addressName = data.addressName
            this.areaData = data
        },
        async onSubmit () {
            if (!this.addressName) {
                Toast('请选择经营区域')
                return false
            }
            if (!this.code) {
                Toast('请输入邀请码')
                return false
            }
            Toast.loading({
                message: '加载中...',
                duration: 0,
                forbidClick: true
            })
            try {
                await this.createCompany({
                    companyName: `${this.userInfo.phone}的公司`,
                    provinceId: this.areaData.provinceId,
                    provinceName: this.areaData.provinceName,
                    cityId: this.areaData.cityId,
                    cityName: this.areaData.cityName,
                    countryId: this.areaData.countryId,
                    countryName: this.areaData.countryName,
                    invitationCode: this.code
                }).then(async (data) => {
                    await this.getUserInfoData()
                    Toast({
                        message: '保存成功',
                        duration: 2000
                    })
                    setTimeout(() => {
                        this.$router.go(-1)
                    }, 2000)
                })
            } catch (error) {
                // Toast.clear()
            }
        },
        async getShareCodeData () {
            const { data } = await getShareCode({
                userId: this.userInfo.id
            })
            this.shareShow = !(data.invitationCode || data.keyManInvitationCode)
            this.code = data.keyManInvitationCode || data.invitationCode
        }
    },
    created () {
        this.getUserInfoData().then((data) => {
            if (data.companyCode) {
                this.$router.push({ path: '/b2b/home/index' })
            }
        })
    },
    mounted () {
        this.userInfo = JSON.parse(localStorage.getItem('userInfo'))
        this.getShareCodeData()
    }
}
</script>
<style lang='scss' scoped>
    .content{
        .tap{
            background: #FFF2E8;
            padding: 22px 32px;
            font-size: 26px;
            color: #FF7A45;
        }
        .inputWidth{
            background: #ffffff;
            padding-left: 32px;
            font-size: 28px;
        }
        .btn{
            margin: 48px 32px;
            line-height: 96px;
            height: 96px;
            border-radius: 96px;
            text-align: center;
            font-size: 34px;
            color: #ffffff;
            background: #FF7A45;
        }
    }
    /deep/ .van-cell {
        padding: 32px 32px 32px 0;
        font-size: 28px;
        color: #000000;
    }
    /deep/ .van-cell--required::before{
        top: 32px;
    }
</style>